/* Lichcards 26-09-2026 (ronde 6) — singles-zoeker: minimalistische, inklapbare filterzijbalk.
   Werkt bovenop sections/lichcards-singles-index.liquid + assets/lichcards-singles-index.js; die doen nog steeds
   al het zoekwerk. Dit script:
   1. toont Rariteit, Taal, Conditie, Afwerking en Editie als aanvinklijst (met aantallen) in plaats van een
      keuzelijst, en Beschikbaarheid/Graded als schakelaar. Een klik zet de waarde van de bestaande (nu verborgen)
      <select> en stuurt een change-event, precies zoals de keuzelijst dat deed. Per groep is één waarde tegelijk
      actief, want zo filtert de zoekserver; nogmaals klikken zet het filter weer uit.
   2. maakt elke filtergroep in- en uitklapbaar (onthouden in deze browser);
   3. zet op desktop een knop "Filters verbergen / tonen" boven de resultaten (onthouden in deze browser);
   4. zet snelle prijskeuzes onder Van/Tot.
   Iconen en opmaak: blok "Ronde 6" onderaan assets/lc-sec-singles-index.css.
   Uitzetten: de script-regel voor dit bestand uit sections/lichcards-singles-index.liquid halen. */
(() => {
  const root = document.getElementById('lc-singles');
  if (!root || root.dataset.lcFx === '1') return;
  root.dataset.lcFx = '1';

  const locale = document.documentElement.lang || 'nl-NL';
  const lang = String(locale).slice(0, 2).toLowerCase();
  const TEXT = {
    nl: { all: 'Toon alle ({n})', less: 'Toon minder', hide: 'Filters verbergen', show: 'Filters tonen', upto: 'Tot {a}', from: 'Vanaf {a}', quick: 'Snelle prijskeuze' },
    en: { all: 'Show all ({n})', less: 'Show less', hide: 'Hide filters', show: 'Show filters', upto: 'Up to {a}', from: 'From {a}', quick: 'Quick price range' },
    de: { all: 'Alle anzeigen ({n})', less: 'Weniger anzeigen', hide: 'Filter ausblenden', show: 'Filter einblenden', upto: 'Bis {a}', from: 'Ab {a}', quick: 'Schnelle Preisauswahl' },
    fr: { all: 'Tout afficher ({n})', less: 'Afficher moins', hide: 'Masquer les filtres', show: 'Afficher les filtres', upto: 'Jusqu’à {a}', from: 'À partir de {a}', quick: 'Prix rapide' },
    es: { all: 'Ver todo ({n})', less: 'Ver menos', hide: 'Ocultar filtros', show: 'Mostrar filtros', upto: 'Hasta {a}', from: 'Desde {a}', quick: 'Precio rápido' },
    it: { all: 'Mostra tutti ({n})', less: 'Mostra meno', hide: 'Nascondi filtri', show: 'Mostra filtri', upto: 'Fino a {a}', from: 'Da {a}', quick: 'Prezzo rapido' },
  };
  const L = TEXT[lang] || TEXT.nl;
  const LIMIT = 7;

  const store = {
    get(key) { try { return window.localStorage.getItem(key); } catch (_e) { return null; } },
    set(key, value) { try { window.localStorage.setItem(key, value); } catch (_e) { /* privé-venster: dan niet onthouden */ } },
  };
  let collapsed;
  try { collapsed = new Set(JSON.parse(store.get('lcSxCollapsed') || '[]')); } catch (_e) { collapsed = new Set(); }

  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const normalizeKey = (value) => String(value || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase()
    .replace(/['’]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim().replace(/\s+/g, '-');
  // Zelfde indeling als rarityTier() in lichcards-singles-index.js (kleur van de lijn onder de kaart).
  const tierOf = (raw) => {
    const value = normalizeKey(raw);
    if (!value) return 'common';
    if (/secret|starlight|ultimate|illustration|alternate|alt-art|hyper|platinum|manga|quarter-century|ghost|collector|enchanted|showcase|serialized|impact-signing|^(?:sec|sar|sir|scr|ur|sp)$/.test(value)) return 'secret';
    if (/ultra|super|double|triple|mythic|gold|shiny|amazing|radiant|(?:^|-)ace(?:-|$)|epic|legend|majestic|character|parallel|prism|vmax|vstar|holo-v|holo-ex|holo-gx|trainer-gallery|special-rare|feature|^(?:sr|rr|rrr|cr|lr|ssr|chr|spr)$/.test(value)) return 'ultra';
    if (/rare|holo|promo|hero|special|^(?:r|pr|rh|p)$/.test(value)) return 'rare';
    if (/uncommon|^(?:u|uc)$/.test(value)) return 'uncommon';
    return 'common';
  };
  const TIER_RANK = { common: 0, uncommon: 1, rare: 2, ultra: 3, secret: 4 };
  // Volgorde in de lijst: Common → Uncommon → Rare → Ultra → Secret; onbekende soorten (Oversized, Online Code Card …) achteraan.
  const rarityRank = (raw) => {
    const value = normalizeKey(raw);
    const tier = tierOf(value);
    if (tier === 'common' && !/(?:^|-)common(?:-|$)|^c$/.test(value)) return 9;
    return TIER_RANK[tier];
  };

  const DEFS = [
    { key: 'rarity', sel: '[data-filter-rarity]', kind: 'list', marker: 'tier', limit: 10 },
    { key: 'language', sel: '[data-filter-language]', kind: 'list', marker: 'flag', sort: 'count' },
    { key: 'condition', sel: '[data-filter-condition]', kind: 'list', marker: 'tone' },
    { key: 'finish', sel: '[data-filter-finish]', kind: 'list' },
    { key: 'edition', sel: '[data-filter-edition]', kind: 'list' },
    { key: 'availability', sel: '[data-filter-availability]', kind: 'seg' },
    { key: 'grading', sel: '[data-filter-grading]', kind: 'seg' },
  ];

  const parseOption = (option) => {
    const text = option.textContent || '';
    const count = (text.match(/\(([\d.,\s]+)\)\s*$/) || [])[1] || '';
    let label = option.dataset.baseLabel || text.replace(/\s*\([\d.,\s]+\)\s*$/, '');
    const icon = option.dataset.visualIcon || '';
    if (icon && label.indexOf(icon) === 0) label = label.slice(icon.length).trim();
    return {
      value: option.value,
      label: label.trim(),
      count: count.trim(),
      n: Number(count.replace(/[^\d]/g, '')) || 0,
      disabled: option.disabled,
      icon,
      tone: option.dataset.visualTone || '',
    };
  };

  const groupLabel = (row) => {
    const head = row.querySelector('.lc-index__filter-label');
    if (!head) return '';
    return Array.from(head.childNodes).filter((node) => node.nodeType === 3).map((node) => node.textContent.trim()).filter(Boolean).join(' ');
  };

  const markerFor = (def, o) => {
    if (def.marker === 'tier') return `<span class="lc-fx__tier" data-tier="${tierOf(o.value || o.label)}" aria-hidden="true"></span>`;
    if (def.marker === 'tone') return `<span class="lc-fx__tone" data-tone="${esc(o.tone || normalizeKey(o.value))}" aria-hidden="true"></span>`;
    if (def.marker === 'flag' && o.icon && o.icon !== '🌐') return `<span class="lc-fx__flag" aria-hidden="true">${esc(o.icon)}</span>`;
    return '';
  };

  const render = (ctx) => {
    const { def, select, box } = ctx;
    const current = select.value;
    let opts = Array.from(select.options).map(parseOption);
    if (def.kind === 'list') opts = opts.filter((o) => o.value !== '');
    if (def.marker === 'tier') {
      opts.sort((a, b) => rarityRank(a.value || a.label) - rarityRank(b.value || b.label) || b.n - a.n || a.label.localeCompare(b.label, locale));
    }
    if (def.sort === 'count') opts.sort((a, b) => b.n - a.n || a.label.localeCompare(b.label, locale));
    const focused = box.contains(document.activeElement) ? document.activeElement : null;
    const focusValue = focused?.dataset.value;
    const focusMore = focused?.classList.contains('lc-fx__more');
    const limit = def.limit || LIMIT;
    const extraCount = def.kind === 'list' ? Math.max(0, opts.length - limit) : 0;
    let html = '';
    opts.forEach((o, index) => {
      const on = o.value === current;
      const off = o.disabled && !on;
      /* Ingeklapt: de extra keuzes niet in de pagina zetten (bij ~185 rariteiten scheelt dat ruim 1.000
         elementen en merkbaar rekentijd bij het laden). "Toon alle" bouwt ze pas op als erom gevraagd wordt. */
      if (extraCount > 0 && !ctx.expanded && index >= limit && !on) return;
      html += `<span class="lc-fx__opt${on ? ' is-on' : ''}${off ? ' is-off' : ''}" role="${def.kind === 'seg' ? 'radio' : 'checkbox'}" aria-checked="${on}"${off ? ' aria-disabled="true"' : ''} tabindex="${off ? -1 : 0}" data-value="${esc(o.value)}">`
        + (def.kind === 'list' ? '<span class="lc-fx__box" aria-hidden="true"></span>' : '')
        + markerFor(def, o)
        + `<span class="lc-fx__label">${esc(o.label)}</span>`
        + (def.kind === 'list' && o.count ? `<span class="lc-fx__n">${esc(o.count)}</span>` : '')
        + '</span>';
    });
    if (extraCount > 0) {
      html += `<span class="lc-fx__more" role="button" tabindex="0" aria-expanded="${ctx.expanded}">${esc(ctx.expanded ? L.less : L.all.replace('{n}', opts.length))}</span>`;
    }
    if (html !== ctx.html) {
      box.innerHTML = html;
      ctx.html = html;
      if (focusMore) box.querySelector('.lc-fx__more')?.focus();
      else if (focusValue != null) {
        const again = Array.from(box.querySelectorAll('.lc-fx__opt')).find((el) => el.dataset.value === focusValue);
        again?.focus();
      }
    }
    const name = groupLabel(ctx.row);
    if (name) box.setAttribute('aria-label', name);
    ctx.row.classList.toggle('lc-fx-has-value', def.kind === 'list' ? Boolean(current) : false);
  };

  const pending = new Set();
  let frame = 0;
  const schedule = (ctx) => {
    pending.add(ctx);
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      const list = Array.from(pending);
      pending.clear();
      list.forEach(render);
    });
  };

  const contexts = [];
  const pick = (event, ctx) => {
    event.preventDefault();
    const more = event.target.closest('.lc-fx__more');
    if (more) {
      ctx.expanded = !ctx.expanded;
      render(ctx);
      return;
    }
    const opt = event.target.closest('.lc-fx__opt');
    if (!opt || opt.getAttribute('aria-disabled') === 'true') return;
    const value = opt.dataset.value;
    const next = ctx.def.kind === 'list' && ctx.select.value === value ? '' : value;
    if (next === ctx.select.value) return;
    ctx.select.value = next;
    ctx.select.dispatchEvent(new Event('change', { bubbles: true }));
    render(ctx);
  };

  const build = (def) => {
    const select = root.querySelector(def.sel);
    const row = select?.closest('[data-filter-row]');
    if (!select || !row || row.querySelector('.lc-fx')) return;
    row.classList.add('lc-fx-row', def.kind === 'seg' ? 'lc-fx-row--seg' : 'lc-fx-row--list');
    select.classList.add('lc-fx-native');
    const box = document.createElement('span');
    box.className = `lc-fx lc-fx--${def.kind}`;
    box.setAttribute('role', def.kind === 'seg' ? 'radiogroup' : 'group');
    box.dataset.fx = def.key;
    row.appendChild(box);
    const ctx = { def, select, row, box, expanded: false, html: '' };
    box.addEventListener('click', (event) => pick(event, ctx));
    box.addEventListener('keydown', (event) => {
      if (event.key !== ' ' && event.key !== 'Enter') return;
      const target = event.target.closest('.lc-fx__opt, .lc-fx__more');
      if (!target) return;
      event.preventDefault();
      target.click();
    });
    new MutationObserver(() => schedule(ctx)).observe(select, {
      childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'],
    });
    select.addEventListener('change', () => schedule(ctx));
    contexts.push(ctx);
    render(ctx);
  };

  /* ---------- in-/uitklappen per groep ---------- */
  const saveCollapsed = () => store.set('lcSxCollapsed', JSON.stringify(Array.from(collapsed)));
  const setupCollapse = (row) => {
    const key = row.dataset.filterRow;
    if (!key || row.dataset.lcFxHead === '1') return;
    let head = null;
    if (row.tagName === 'FIELDSET') {
      const legend = row.querySelector(':scope > legend');
      if (!legend) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lc-fx-head lc-fx-head--legend';
      while (legend.firstChild) button.appendChild(legend.firstChild);
      legend.appendChild(button);
      head = button;
    } else {
      head = row.querySelector(':scope > .lc-index__filter-label');
      if (!head) return;
      head.classList.add('lc-fx-head');
      head.setAttribute('role', 'button');
      head.tabIndex = 0;
    }
    row.dataset.lcFxHead = '1';
    if (collapsed.has(key)) row.classList.add('lc-fx-collapsed');
    const sync = () => head.setAttribute('aria-expanded', String(!row.classList.contains('lc-fx-collapsed')));
    const toggle = (event) => {
      event.preventDefault();
      event.stopPropagation();
      row.classList.toggle('lc-fx-collapsed');
      if (row.classList.contains('lc-fx-collapsed')) collapsed.add(key);
      else collapsed.delete(key);
      saveCollapsed();
      sync();
    };
    head.addEventListener('click', toggle);
    if (head.tagName !== 'BUTTON') {
      head.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') toggle(event);
      });
    }
    sync();
  };

  /* ---------- zijbalk verbergen (desktop) ---------- */
  const setupSidebarToggle = () => {
    const toolbar = root.querySelector('.lc-index__toolbar');
    const panel = root.querySelector('[data-index-filters-panel]');
    if (!toolbar || !panel || toolbar.querySelector('.lc-fx-side')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'lc-fx-side';
    if (panel.id) button.setAttribute('aria-controls', panel.id);
    button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1"/><circle cx="15" cy="6" r="2"/><circle cx="9" cy="12" r="2"/><circle cx="17" cy="18" r="2"/></svg><span class="lc-fx-side__label"></span><span class="lc-fx-side__count" hidden></span>';
    const label = button.querySelector('.lc-fx-side__label');
    const sync = () => {
      const hidden = root.classList.contains('lc-fx-hidden');
      button.setAttribute('aria-expanded', String(!hidden));
      label.textContent = hidden ? L.show : L.hide;
    };
    button.addEventListener('click', () => {
      root.classList.toggle('lc-fx-hidden');
      store.set('lcSxFiltersHidden', root.classList.contains('lc-fx-hidden') ? '1' : '0');
      sync();
    });
    toolbar.prepend(button);
    sync();
    // Aantal actieve filters op de knop (zelfde teller als de mobiele Filters-knop).
    const source = root.querySelector('[data-index-filter-count]');
    const badge = button.querySelector('.lc-fx-side__count');
    const syncCount = () => {
      if (!source || !badge) return;
      badge.textContent = source.textContent;
      badge.hidden = source.hidden || !Number(source.textContent);
    };
    if (source) new MutationObserver(syncCount).observe(source, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    syncCount();
  };

  /* ---------- snelle prijskeuzes ---------- */
  let syncPrice = () => {};
  const setupPrice = () => {
    const group = root.querySelector('[data-filter-price-group]');
    const min = root.querySelector('[data-filter-min]');
    const max = root.querySelector('[data-filter-max]');
    const fields = group?.querySelector('.lc-index__price-fields');
    if (!group || !min || !max || !fields || group.querySelector('.lc-fx-price')) return;
    let money;
    try { money = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }); } catch (_e) { money = { format: (n) => `€${n}` }; }
    const ranges = [[0, 1], [1, 5], [5, 20], [20, 50], [50, 0]];
    const wrap = document.createElement('div');
    wrap.className = 'lc-fx-price';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', L.quick);
    wrap.innerHTML = ranges.map(([a, b]) => {
      const text = !a ? L.upto.replace('{a}', money.format(b)) : !b ? L.from.replace('{a}', money.format(a)) : `${money.format(a)} – ${money.format(b)}`;
      return `<button type="button" data-min="${a || ''}" data-max="${b || ''}" aria-pressed="false">${esc(text)}</button>`;
    }).join('');
    fields.after(wrap);
    syncPrice = () => {
      wrap.querySelectorAll('button').forEach((button) => {
        const on = button.dataset.min === String(min.value || '') && button.dataset.max === String(max.value || '') && Boolean(min.value || max.value);
        button.setAttribute('aria-pressed', String(on));
      });
    };
    wrap.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      const on = button.getAttribute('aria-pressed') === 'true';
      min.value = on ? '' : button.dataset.min;
      max.value = on ? '' : button.dataset.max;
      max.dispatchEvent(new Event('change', { bubbles: true }));
      syncPrice();
    });
    [min, max].forEach((input) => input.addEventListener('input', syncPrice));
    syncPrice();
  };

  /* ---------- alles bijwerken na elke zoekopdracht ---------- */
  const syncAll = () => {
    contexts.forEach(schedule);
    syncPrice();
  };

  const init = () => {
    if (root.dataset.lcFxReady === '1') return;
    root.dataset.lcFxReady = '1';
    DEFS.forEach(build);
    root.querySelectorAll('[data-index-filters-panel] [data-filter-row]').forEach(setupCollapse);
    setupSidebarToggle();
    setupPrice();
    const count = root.querySelector('[data-index-count]');
    if (count) new MutationObserver(syncAll).observe(count, { childList: true, characterData: true, subtree: true });
    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-index-clear-filters], [data-filter-chip], [data-index-reset-all]')) window.setTimeout(syncAll, 0);
    });
    root.classList.add('lc-fx-ready');
  };

  if (root.dataset.filtersReady === 'true') init();
  else {
    const waiter = new MutationObserver(() => {
      if (root.dataset.filtersReady !== 'true') return;
      waiter.disconnect();
      init();
    });
    waiter.observe(root, { attributes: true, attributeFilter: ['data-filters-ready'] });
  }
})();
